import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { Block } from '@/types/blocks';
import { resolveAppearance, type PublicBranding } from './brandingVars';
import type { AppearanceFields } from '@/features/themes/lib/appearance';

export interface SiteChromeTemplate {
  blocks: Block[];
  appearance: AppearanceFields;
}

async function fetchTemplate(id: string | null | undefined, fallbackBranding?: PublicBranding | null): Promise<SiteChromeTemplate | null> {
  if (!id) return null;
  const { data, error } = await supabase.from('appearance_templates').select('*').eq('id', id).single();
  if (error) throw error;
  return {
    blocks: (data.content as unknown as Block[]) ?? [],
    appearance: resolveAppearance(fallbackBranding, data),
  };
}

/** Busca os blocos do header/footer ativo do site (quando configurado em Aparência). */
export function useSiteChrome(
  headerTemplateId: string | null | undefined,
  footerTemplateId: string | null | undefined,
  fallbackBranding?: PublicBranding | null,
) {
  const { data: headerTemplate } = useQuery({
    queryKey: ['chrome-template', headerTemplateId, fallbackBranding],
    queryFn: () => fetchTemplate(headerTemplateId, fallbackBranding),
    enabled: !!headerTemplateId,
  });
  const { data: footerTemplate } = useQuery({
    queryKey: ['chrome-template', footerTemplateId, fallbackBranding],
    queryFn: () => fetchTemplate(footerTemplateId, fallbackBranding),
    enabled: !!footerTemplateId,
  });
  return { headerTemplate, footerTemplate };
}
